import { sessionStorage, STORAGE_KEYS } from "./sessionStorage.js";

export const PERMISSIONS = {
  camera: true,
  mic: true,
  screenShare: true,
  startMeeting: true,
  userMeetingJoin: true,
  sectionAccess: true,
  pollAccess: true,
  qnaAccess: true,
  chatAccess: true,
  quizAccess: true,
};

export const DEFAULT_PERMISSIONS = {
  userType: "moderator",
  ...PERMISSIONS,
};

export const TAB_PERMISSIONS = {
  components: "sectionAccess",
  poll: "pollAccess",
  qna: "qnaAccess",
  chat: "chatAccess",
  interactiveQuiz: "quizAccess",
};

function getAdminPermission() {
  const data = sessionStorage.get(STORAGE_KEYS.AUTH_IDENTITY);
  return data?.permission || null;
}

export function hasAdminPermission(key) {
  const perm = getAdminPermission();
  return perm?.[key] === true;
}
